import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import { Apellido } from './Apellido';

export interface IApellidoEditProps {
    open: boolean;
    onClose?: Function;
    onSave?: Function;
    selectedItem: Apellido | undefined;
}

export interface IApellidoEditState {
    open: boolean;
    hasErrors: boolean;
    errorMessage: string;
}

export default class ApellidoEdit extends React.Component<IApellidoEditProps, IApellidoEditState> {
    _apellido: Apellido = new Apellido();
    _id: number = -1;
    
    public constructor(props: IApellidoEditProps) {
        super(props);

        this.state = {
            open: false,
            hasErrors: false,
            errorMessage: ''
        }
    }

    componentWillReceiveProps(nextProps: Readonly<IApellidoEditProps>, nextContext: any): void {
        if(nextProps.selectedItem != null) {
            this._apellido = nextProps.selectedItem;
        }

        this.setState({
            open: nextProps.open
        });
    }

    public render(): React.ReactElement<{}> {
        return (
            <Dialog open={this.state.open} fullWidth>
                <DialogTitle>
                    Modificar apellido
                </DialogTitle>
                <DialogContent>
                    {
                        this.state.hasErrors && (
                            <Alert severity="error" style={{marginBottom: '10px'}}>
                                {
                                    this.state.errorMessage
                                }
                            </Alert>
                        )
                    }
                    <Box>
                        <FormControl fullWidth style={{marginBottom: '20px'}}>
                            <TextField required variant='standard' label='Apellido' defaultValue={this._apellido.apellido} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                if(event.target.value == '') {
                                    this.setState(
                                        {
                                            hasErrors: true,
                                            errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios.'
                                        }
                                    );
                                }
                                else {
                                    this.setState(
                                        {
                                            hasErrors: false,
                                            errorMessage: ''
                                        }
                                    );
                                    this._apellido.apellido = event.target.value;
                                }
                            }}></TextField>
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.Update.bind(this)}>OK</Button>
                    <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                </DialogActions>
            </Dialog>
        )
    }

    private Close() {
        this.setState(
            {
                open: false,
                hasErrors: false,
                errorMessage: ''
            }
        );

        if(this.props.onClose != null) {
            this.props.onClose();
        }
    }

    private Update() {
        if(this._apellido.apellido == '' || this._apellido.apellido == null) {
            this.setState({
                hasErrors: true,
                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
            })
            return;
        }

        let url = `${Common.END_POINT}/masters/apellidos/${this._apellido.id}/update`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._apellido),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._apellido = new Apellido();
        }).fail((jqXHR, textStatus, errorThrown) => {
            this.setState(
                {
                    open: false
                }
            );
    
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._apellido = new Apellido();
        });
    }
}